export var attachScriptToHTML = function (content, scriptType, callback) {
    var script = document.createElement('script');
    script.type = scriptType;
    if (scriptType === "module") {
        script.textContent = content;
    }
    else if (scriptType === "text/javascript") {
        script.src = content;
    }
    if (callback) {
        script.onload = function () { return callback(); };
    }
    document.head.appendChild(script);
};
